<script setup lang="tsx">
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useModalStore } from '@/stores/modal'
import { Modal } from 'bootstrap'

const store = useModalStore()

const modalRef = ref<HTMLElement | null>(null)

let modalInstance: Modal | null = null
let modalShown = false

onMounted(() => {
	const modalElement = modalRef.value
	if (modalElement) {
		modalInstance = new Modal(modalElement, {
			backdrop: 'static',
		})

		modalElement.addEventListener('shown.bs.modal', () => {
			modalShown = true

			if (!store.isVisible) {
				store.isVisible = true
			}
		})

		modalElement.addEventListener('hidden.bs.modal', () => {
			modalShown = false

			if (store.isVisible) {
				store.isVisible = false
			}
		})

		if (store.isVisible) {
			modalInstance.show()
		}
	}
})

onBeforeUnmount(() => {
	if (modalInstance) {
		modalInstance.dispose()
	}
})

watch(
	() => store.isVisible,
	(newValue) => {
		if (modalInstance) {
			if (newValue && !modalShown) {
				modalInstance.show()
			} else if (!newValue && modalShown) {
				modalInstance.hide()
			}
		}
	},
)
</script>

<template>
	<div ref="modalRef" class="modal fade" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<slot name="title">
						<h5 class="modal-title w-100">{{ store.header }}</h5>
					</slot>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<slot name="body">
						<p>{{ store.body }}</p>
					</slot>
				</div>
				<div class="modal-footer">
					<div v-if="store.footer">
						<slot name="footer">
							<component :is="store.footer"></component>
						</slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
